export const getModelEspecialidad = () => ({
  iIdEspecialidad: 0,
});

export const getFormEspecialidad = () => ({
  txtNombreEspecialidad: {
    label: "Nombre de la especialidad:",
    required: true,
    value: "",
    error: false,
    message: "El nombre de la especialidad es requerido",
  },
});

export const getEspecialidadColumns = () => [
  { title: "ID", field: "iIdEspecialidad" },
  { title: "Descripción", field: "sNombre" },
  { title: "Creado", field: "sFechaCreacion" },
];
